import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Button,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, AlertListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/alert';
import { getToken } from 'src/utils/common';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'acc', label: 'Alert Id', alignRight: false },
  { id: 'name', label: 'File Name', alignRight: false },
  { id: 'dataset', label: 'Dataset', alignRight: false },
  { id: 'Amount', label: 'Type', alignRight: false },
  { id: 'numberOfChanges', label: 'Number Of Changes', alignRight: false },
  { id: 'time', label: 'Date & Time', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'Aksi', label: 'Aksi  ', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);
  const [total, settotal] = useState(1);
  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [data, setData] = useState('');
  const [data2, setData2] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const dataToShare = {
    name: 'John Doe',
    age: 30,
  };
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const navigate = useNavigate();

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
    fetchInfo(window.REACT_APP_API_PURE + `alert/list?limit=${parseInt(event.target.value, 10)}`);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
    fetchInfo(window.REACT_APP_API_PURE + `alert/list?alert_name=${event.target.value}`);
  };

  const handleClicker = () => {
    navigate('/dashboard/alertdetail', { replace: true });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const fetchInfo = (url) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData(d);
        settotal(d.total);
      });
  };

  const url2 = window.REACT_APP_API_PURE + 'reference/list?kode=F003';

  const fetchInfo2 = () => {
    return fetch(url2, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData2(d);
      });
  };
  useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'alert/list');
    fetchInfo2();
  }, []);

  return (
    <>
      <Helmet>
        <title> Alert Management | SmartShield </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alert
          </Typography>
        </Stack>

        <Card>
          <AlertListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  // order={order}
                  // orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {data?.data?.map((index, row, dataObj) => {
                    // const { id, name, role, company, avatarUrl, isVerified } = row;
                    // const selectedUser = selected.indexOf(name) !== -1;
                    const channel2 = data2?.data?.find((val) => val.id === index.channel);

                    const dateString = moment.unix(index.created_at).format('YYYY-MM-DD HH:mm');

                    const parts = index?.alert_id.split('-');
                    const firstPart = parts[0] || '';
                    const secondPart = parts[1] || '';

                    return (
                      <TableRow hover key={row}>
                        <TableCell component="th" scope="row" alignItems="center">
                          {row + 1}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.id.split('-').pop()}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.name}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {channel2?.label || ''}
                          {index.type}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {firstPart}-{secondPart}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="right">
                          {index.severity}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {dateString}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <span
                            style={{
                              backgroundColor:
                                index.status === 'Open'
                                  ? 'red'
                                  : index.status === 'Process'
                                  ? 'orange'
                                  : index.status === 'Pending Approval'
                                  ? 'blue'
                                  : 'green',
                              fontSize: 15,

                              color: 'white',
                              borderRadius: 10,
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 150,
                            }}
                          >
                            {index.status === 'Process' ? 'In Progress' : index.status}
                          </span>
                        </TableCell>

                        <TableCell>
                          <Button variant="outlined" size="small" style={{ borderRadius: 20 }}>
                            Detail
                          </Button>
                          {/* {
                            <Link
                              to={{
                                pathname: `/dashboard/alertdetail/${2}`,
                              }}
                              state={{ index, channel: channel2?.label || '', date: dateString }}
                            >
                              <VisibilityIcon />
                            </Link>
                          } */}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleClicker}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover>
    </>
  );
}
